module.exports = __webpack_public_path__ + "img/logo-text-blue.cc2aa040.png";